<script>
import datePickComponent from 'vue-date-pick';

export default {
  data() {
    return {
      sent_date: '',
      tracking: '',
      comment: '',
    };
  },
  components: {
    date_pick_component: datePickComponent,
  },
  computed: {
    isButtonActive() {
      return !!this.sent_date && !!this.tracking;
    },
  },
  methods: {
    save() {
      const data = {
        shop_id: this.$store.state.shops.shop_id,
        track_number: this.tracking,
        sent_date: this.sent_date,
        client_comment: this.comment,
      };

      this.$store.dispatch('ib_create_order', data)
        .then(() => this.$store.commit('set_instock_modal_order', null));
    },

    close(event) {
      if (!event.target.closest('.modal-container') || event.target.classList.contains('close')) {
        this.$store.commit('set_instock_modal_order', null);
      }
    },
  },
};
</script>
<template src="./create_order.pug" lang="pug"></template>
